import { FETCH_QUOTEID_DOCUMENTS } from '../actions/actiontypes'

const INIT_STATE = {
    loading: true
}

export default function (state = INIT_STATE, action) {
    switch (action.type) {
        case FETCH_QUOTEID_DOCUMENTS:
            return { ...state, documents: action.payload, loading:false };
        default:
			return state;
    }
}
